import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Routes, Route, useLocation, Navigate, useNavigate } from "react-router-dom"

import {
  Login,
  Ledger,
  Companies,
  Dashboard,
  GrayStock,
  AccountLedger,
  GrayStockDetail,
  OutPPartyDetail,
  OutRPartyDetail,
  OutPPartySummary,
  OutRPartySummary,
  OutRPartyAgeSummary,
  OutPPartyAgeSummary,
  SalesData,
  SalesOrderSummary,
  ReportViewer,
  Stock,
  CreditDebitNote,
  InvoiceDataList,
  Test,
  AccountMaster,
  CreateAccountMaster,
  CreateItemMaster,
  ItemMaster,
  ResetPassword,
  GrayProduction,
  CreateReceiveEntry,
  ReceiveEntryMaster,
  MultiLedger,
  MultiAccountLedger,
  PaymentEntryMaster,
  CreatePaymentEntry,
  CreateModeSetting,
  SalesOrderMaster,
  CreateSalesOrder,
  CreateProductionEntry,
  ProductionEntryMaster,
  CreateBeamCardEntry,
  BeamCardEntryMaster,
  TextileMasterDashboard,
  CreateJournalEntry,
  JournalVoucherEntryMaster,
  SaleEntryMaster,
  CreateSaleEntry,
  CreatePurchaseEntry,
  PurchaseEntryMaster,
  InterestCalculation,
  CreateChallanEntry,
  ChallanEntryMaster,
  UserCompnayMaping,
  MainGst,
  GstLedger,
  GstPeriodicSummary,
  GstRegister,
  FinishStock,
  GenFasOrderSummary,
  GrayItemCostingDashboard

} from "./pages/index.js"

import { linksUrl } from "./constants/enum.js"
import PrivateRoute from "./PrivateRoute.jsx"
import { SideNav, Nav, TokenExpired } from "./components/index.js"
import { Drawer, IconButton } from "@mui/material"
import { faClosedCaptioning, faSquareXmark, faWarning } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { toast } from "react-toastify"
import MonthExpEntryMaster from "./pages/monthexpense/MonthExpEntryMaster.jsx"


//import Test from "./pages/sample/Test.jsx"

function App() {
  const location = useLocation()
  const { isAuthenticated, tokenExpiry, } = useSelector((state) => state.auth)
  const { compCode } = useSelector((state) => state.company)
  let navigate = useNavigate();

  const [openDrawer, setOpenDrawer] = useState(false);
  useEffect(() => {
    if (!isAuthenticated)
      navigate(linksUrl.login)

    if (tokenExpiry && tokenExpiry != "" && !toast.isActive('toast_tkexp') && !toast.isActive('toast_tknf')) {
      const currentTime = new Date().getTime() / 1000;
      //let timeRemaining = tokenExpiry - currentTime
      if (currentTime > tokenExpiry) {
        setOpenDrawer(true)
      }
    }
  }, [])

  // const showAlert = () => {
  //   //alert('Your token is about to expire in 5 minutes!');
  //   toast.error("Your token is about to expire in 5 minutes!", {
  //     "position": "top-center"
  //   })
  // };

  // useEffect(() => {
  //   if (tokenExpiry && tokenExpiry != "") {
  //     const currentTime = new Date().getTime() / 1000;
  //     let timeRemaining = tokenExpiry - currentTime
  //     if (currentTime > tokenExpiry) {
  //       setOpenDrawer(true)
  //       // window.location.href=linksUrl.login
  //     }

  //     if (timeRemaining > 300) {
  //       // Set a timer to show an alert 5 minutes before token expiry
  //       const alertTimeout = setTimeout(showAlert, (timeRemaining - 300) * 1000);

  //       // Cleanup the timeout on component unmount
  //       return () => clearTimeout(alertTimeout);
  //     }

  //     if (timeRemaining <= 300) {
  //       showAlert();
  //     }
  //   }
  // }, [])

  const hanldeClick = () => {
    setOpenDrawer(false)
    navigate(linksUrl.login)
  }
  const pages = [
    {
      path: linksUrl.test,
      component: <Test />,
      name: "Companies",
    },
    {
      path: linksUrl.companies,
      component: <Companies />,
      name: "Companies",
    },
    {
      path: linksUrl.monthExpense.monthExpEntryMaster,
      component: <MonthExpEntryMaster/>,
      name: "MonthExpenseEntry",
    },
    {
      path: linksUrl.userCompMaping.get,
      component: <UserCompnayMaping />,
      name: "UserCompanyMapingWebApp",
    },
    {
      path: linksUrl.dashboard.tradingDashboard,
      component: <Dashboard />,
      name: "Dashboard",
    },
    {
      path: linksUrl.dashboard.tradingDashboard + "/:rcid",
      component: <Dashboard />,
      name: "Dashboard",
    },
    {
      path: linksUrl.dashboard.masterDashboard,
      component: <TextileMasterDashboard />,
      name: "MasterDashboard",
    },
     {
      path: linksUrl.dashboard.itemWistCostDashboard,
      component: <GrayItemCostingDashboard />,
      name: "GrayItemCostingDashboard",
    },
    {
      path: linksUrl.resetPassword,
      component: <ResetPassword />,
      name: "Companies",
    },
    {
      path: linksUrl.gstReport.mainGst,
      component: <MainGst />,
      name: "GstReport",
    },
    {
      path: linksUrl.gstReport.GstLedger,
      component: <GstLedger />,
      name: "GstReport",
    },
    {
      path: linksUrl.gstReport.GstPeriodicSummary,
      component: <GstPeriodicSummary />,
      name: "GstReport",
    },
    {
      path: linksUrl.gstReport.GstRegister,
      component: <GstRegister />,
      name: "GstReport",
    },

    {
      path: linksUrl.item.createItemMaster,
      component: <CreateItemMaster />,
      name: "ItemMaster",
    },
    {
      path: linksUrl.item.itemMaster,
      component: <ItemMaster />,
      name: "ItemMaster",
    },
    {
      path: linksUrl.account.accountMaster,
      component: <AccountMaster />,
      name: "AccountMaster",
    },
    {
      path: linksUrl.account.createAccountMaster,
      component: <CreateAccountMaster />,
      name: "AccountMaster",
    },

    {
      path: linksUrl.modeSetting.createmodSettingMaster,
      component: <CreateModeSetting />,
      name: "CreateModSetting",
    },
    {
      path: linksUrl.transaction.creditDebitEntry.invoicedatalist,
      component: <InvoiceDataList />,
      name: "CreditDebitNote",
    },
    {
      path: linksUrl.transaction.creditDebitEntry.creditdebitnote,
      component: <CreditDebitNote />,
      name: "CreditDebitNote",
    },
    {
      path: linksUrl.report.invoice.invoiceSummary,
      component: <SalesData />,
      name: "SalesData",
    },
    {
      path: linksUrl.transaction.salesOrderEntry.createOrderEntry,
      component: <CreateSalesOrder />,
      name: "SalesOrderMaster",//"Dashboard"
    },

    {
      path: linksUrl.transaction.salesOrderEntry.orderEntryMaster,
      component: <SalesOrderMaster />,
      name: "SalesOrderMaster",
    },
    {
      path: linksUrl.transaction.salesOrderEntry.createOrderEntry,
      component: <CreateSalesOrder />,
      name: "GenFasSaleOrderEntry",//"Dashboard"
    },

    {
      path: linksUrl.transaction.salesOrderEntry.orderEntryMaster,
      component: <SalesOrderMaster />,
      name: "GenFasSaleOrderEntry",
    },
    {
      path: linksUrl.report.invoice.rptInvoice,
      component: <ReportViewer />,
      name: "SalesData",
    },
    {
      path: linksUrl.sales.salesorder,
      component: <SalesOrderSummary />,
      name: "SalesOrderSummary",
    },
    {
      path: linksUrl.sales.ordersummary,
      component: <GenFasOrderSummary />,
      name: "GenFasSaleOrderSummary",
    },
    {
      path: linksUrl.transaction.journalVoucherEntry.journalVoucherEntryMaster,
      component: <JournalVoucherEntryMaster />,
      name: "JournalVoucherEntryMaster"
    },
    {
      path: linksUrl.transaction.journalVoucherEntry.createJournalVoucherEntry,
      component: <CreateJournalEntry />,
      name: "JournalVoucherEntryMaster"
    },

    {
      path: linksUrl.outstanding.receivable.partySummary,
      component: <OutRPartySummary />,
      name: "OutRPartySummary",
    },
    {
      path: linksUrl.outstanding.receivable.partyAgingSummary,
      component: <OutRPartyAgeSummary />,
      name: "OutRPartyAgeSummary",
    },
    {
      path: linksUrl.outstanding.receivable.partyDetail,
      component: <OutRPartyDetail />,
      name: "OutRPartyDetail",
    },
    {
      path: linksUrl.outstanding.payable.partySummary,
      component: <OutPPartySummary />,
      name: "OutPPartySummary",
    },
    {
      path: linksUrl.outstanding.payable.partyAgingSummary,
      component: <OutPPartyAgeSummary />,
      name: "OutPPartyAgeSummary",
    },
    {
      path: linksUrl.outstanding.payable.partyDetail,
      component: <OutPPartyDetail />,
      name: "OutPPartyAgeSummary",
    },
    {
      path: linksUrl.outstanding.interestCalc + ":billid",
      component: <InterestCalculation />,
      name: "InterestCalculation",// "InterestCalculation",
    },
    {
      path: linksUrl.ledger.get,
      component: <Ledger />,
      name: "Ledger",
    },
    {
      path: linksUrl.ledger.getAccount,
      component: <AccountLedger />,
      name: "Ledger",
    },
    {
      path: linksUrl.multiCompLedger.get,
      component: <MultiLedger />,
      name: "OutPPartyAgeSummary",
    },
    {
      path: linksUrl.multiCompLedger.getAccount,
      component: <MultiAccountLedger />,
      name: "OutPPartyAgeSummary",
    },
    {
      path: linksUrl.grayStock.get,
      component: <GrayStock />,
      name: "GrayStock",
    },
    {
      path: linksUrl.grayStock.detail,
      component: <GrayStockDetail />,
      name: "GrayStockDetail",
    },
    {
      path: linksUrl.stock.get,
      component: <Stock />,
      name: "Stock",
    },
    {
      path: linksUrl.stock.getFinishStock,
      component: <FinishStock />,
      name: "FinishProductStock",
    },
    {
      path: linksUrl.production.grayProduction,
      component: <GrayProduction />,
      name: "GrayProduction",
    },
    {
      path: linksUrl.transaction.receiveEntry.receiveEntryMaster,
      component: <ReceiveEntryMaster />,
      name: "ReceiveEntryMaster",
    },
    {
      path: linksUrl.transaction.receiveEntry.createEntry,
      component: <CreateReceiveEntry />,
      name: "ReceiveEntryMaster",
    },
    {
      path: linksUrl.transaction.paymentEntry.paymntEntryMaster,
      component: <PaymentEntryMaster />,
      name: "PaymentEntryMaster",
    },
    {
      path: linksUrl.transaction.paymentEntry.createEntry,
      component: <CreatePaymentEntry />,
      name: "PaymentEntryMaster",
    },
    // {
    //   path: linksUrl.transaction.graySaleChallanEntry.createGraySaleChallanEntry,
    //   component: <CreateGraySaleChallanEntry />,
    //   name: "GraySaleChallanEntryMaster",
    // },
    // {
    //   path: linksUrl.transaction.graySaleChallanEntry.graySaleChallanEntryMaster,
    //   component: <GraySaleChallanEntryMaster />,
    //   name: "GraySaleChallanEntryMaster",
    // },
    {
      path: linksUrl.transaction.SalesEntry + ":typeid",
      component: <SaleEntryMaster />,
      name: "SaleEntryMaster",
    },
    {
      path: linksUrl.transaction.SalesEntry + ":typeid/create-entry",
      component: <CreateSaleEntry />,
      name: "SaleEntryMaster",
    },
    {
      path: linksUrl.transaction.PurchaseEntry + ":typeid",
      component: <PurchaseEntryMaster />,
      name: "PurchaseEntryMaster",
    },
    {
      path: linksUrl.transaction.PurchaseEntry + ":typeid/create-entry",
      component: <CreatePurchaseEntry />,
      name: "PurchaseEntryMaster",
    },

    {
      path: linksUrl.transaction.ChallanEntry + ":challntype/:challnid",
      component: <ChallanEntryMaster />,
      name: "SaleEntryMaster",
    },
    {
      path: linksUrl.transaction.ChallanEntry + ":challntype/:challnid/create-entry",
      component: <CreateChallanEntry />,
      name: "SaleEntryMaster",
    },

    {
      path: linksUrl.transaction.ChallanEntry + ":challntype/:challnid",
      component: <ChallanEntryMaster />,
      name: "PurchaseEntryMaster",
    },
    {
      path: linksUrl.transaction.ChallanEntry + ":challntype/:challnid/create-entry",
      component: <CreateChallanEntry />,
      name: "PurchaseEntryMaster",
    },
    {
      path: linksUrl.beamTransaction.beamCardEntry.createEntry,
      component: <CreateBeamCardEntry />,
      name: "Dashboard",
    },
    {
      path: linksUrl.beamTransaction.beamCardEntry.beamCardEntryMatser,
      component: <BeamCardEntryMaster />,
      name: "Dashboard",
    },
    {
      path: linksUrl.production.createProdcutionEntry,
      component: <CreateProductionEntry />,
      name: "GrayProductionEntry",
    },
    {
      path: linksUrl.production.ProdcutionEntryMaster,
      component: <ProductionEntryMaster />,
      name: "GrayProductionEntry",
    },
  ]

  const shouldShowSidebar = () => {
    const { pathname } = location
    return !["/login", "/signup", "/sidenav"].includes(pathname) //when path incude this not showside bar
  }
  return (
    <div className="relative">
      <Drawer open={openDrawer} anchor="top"  >
        <FontAwesomeIcon onClick={hanldeClick} className=" p-3 cursor-pointer text-blue-800 text-3xl absolute right-0" icon={faSquareXmark} />
        <div className="text-center font-semibold p-8 text-gray-800 border-2 border-b-gray-700">
          <FontAwesomeIcon className="text-rose-500" icon={faWarning} ></FontAwesomeIcon> Token Has Expired !
        </div>
      </Drawer>

      {shouldShowSidebar() && <Nav />}
      {shouldShowSidebar() && <SideNav />}
      {/* Routes */}
      <Routes>
        {/* Sample - to check ui*/}
        {/* ene of sample */}
        <Route
          path={linksUrl.login}
          element={
            !isAuthenticated ? <Login /> : <Navigate to={linksUrl.companies} />
          }
        />

        {/* private routes */}
        {/* 
          <Route
            path={linksUrl.dashboard}
            element={
              <PrivateRoute authorized={true}>
                <Dashboard />
              </PrivateRoute>
            }
          /> */}

        {pages.map((page, index) => {
          //if (page !== "report") {
          return (
            <Route
              key={index}
              path={page.path}
              element={
                <PrivateRoute page={page}>{page.component}</PrivateRoute>
              }
            />
          )
        })}
      </Routes>
      <div id="footer"></div>
    </div>
  )
}

export default App
